import { useMemo } from 'react';

import { IEmployee } from '@entities/employee/model/types';

interface IUseGetEmployeeFieldValue<FieldName extends keyof IEmployee> {
    employeesData: IEmployee[];
    fieldName: FieldName;
    currentClickedId: IEmployee['id'];
}

export const useGetEmployeeFieldValue = <FieldName extends keyof IEmployee>({
    employeesData,
    fieldName,
    currentClickedId,
}: IUseGetEmployeeFieldValue<FieldName>): IEmployee[FieldName] | undefined => {
    const currentEmployee = useMemo(
        () => employeesData?.find((employee) => employee?.id === currentClickedId),
        [employeesData, currentClickedId]
    );

    return currentEmployee?.[fieldName];
};
